export default "__VITE_ASSET__DVSQcp6i__ 400w, __VITE_ASSET__Bl__VEZa__ 800w, __VITE_ASSET__CujV4bQu__ 1024w";